"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fusion_1 = require("./fusion");
var common_1 = require("../common");
var util_1 = require("../../util");
var msgId = 0;
function fusion(app) {
    var _Fusion = new fusion_1.default(app);
    !_Fusion.init() && (_Fusion = window.Fusion);
    window.WebViewUtilFusion = _Fusion;
    var cmnID = util_1.randomId();
    return function (method, params, callback, module) {
        if (callback === void 0) { callback = util_1.noop; }
        msgId++;
        var msgCode = cmnID + "_" + msgId;
        var instance = module ? _Fusion.loadModule(module) : _Fusion;
        if (instance[method]) {
            instance[method](params, function (data) {
                callback.call(this, data);
                try {
                    util_1.logger({
                        pos: 'COMMUNICATION_FUSION_RES',
                        id: msgCode,
                        method: method,
                        params: JSON.stringify(data)
                    });
                }
                catch (e) { }
            });
            util_1.logger({
                pos: 'COMMUNICATION_FUSION',
                id: msgCode,
                method: method,
                params: JSON.stringify({
                    method: method,
                    params: params
                })
            });
        }
    };
}
exports.default = common_1.createCommunicationFactory(fusion, 'fusion');
